import htmlReactParser from "html-react-parser";
import { isNil, isEmpty } from "lodash";
import config from "src/config";

export const consoleLog = (key, value) => {
  if (config.vconsole.enabled) {
    console.log(key, value);
  }
};

export const getPathFromRoutes = (routes: any[]) => {
  for (let i = 0; i < routes.length; i++) {
    const element = routes[i];

    if (!isArrayEmpty(element.children)) {
      return getPathFromRoutes(element.children);
    }

    return element.path;
  }
};

export function safeDecodeURIComponent(str: string) {
  if (typeof str !== "string") {
    str = "" + str;
  }

  let counter = 10;
  let good = decodeURIComponent(str);
  while (str !== good && counter > 0) {
    str = decodeURIComponent(str);
    good = decodeURIComponent(good);
    counter--;
  }

  return good;
}

export function isHexadecimal(str: string) {
  if (/^[0-9a-fA-F]+$/.test(str)) {
    return true;
  } else {
    return false;
  }
}

export function isObjectEmpty(obj: any) {
  return isNil(obj) || isEmpty(obj);
}

export function isArrayEmpty(obj: any) {
  return !(obj && Array.isArray(obj) && obj.length);
}

export function parseISOString(s: string) {
  const b = s?.split(/\D+/) as any;
  return new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5], b[6]));
}

export function convertToQueryString(obj) {
  const str = [];
  for (const p in obj)
    if (obj.hasOwnProperty(p) && obj[p]) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }
  return str.join("&");
}

export function renderStringAsHTMLParser(strHtml: string, transform?: any) {
  const options = {} as any;
  if (transform) {
    options.transform = transform;
  }
  return htmlReactParser(strHtml, options);
}
